import React, { useEffect, useState } from "react";
import { Checkbox, Col, Form, Modal, Progress, Row, Skeleton, Spin, Switch, Table } from "antd";
import { FlexCol, FlexRow } from "../../../components/Container/Container";
import { ProductName } from "../../Shared/AddProduct";
import Text from "../../../components/Text/Text";
import { numberFormatter } from "../../../utility/Formatter";
import { FormInstance } from "antd/lib";
import TableContainer from "../../../components/Table/TableContainer";
import Input from "../../../components/Input/Input";
import { CloseOutlined, PlusOutlined, ScanOutlined, SearchOutlined } from "@ant-design/icons";
import Select from "../../../components/Select/Select";
import { dealerTypeName } from "../../../definitions/campaign";
import Button from "../../../components/Button/Button";
import icon from "../../../resource/icon";
import { handleNumberOnlyCopyPaste } from "../../../utility/validator";
import styled from "styled-components";
import { ActionBtnWhite } from "../../../components/Button/TableActionButton";
import color from "../../../resource/color";
import StatusBadge from "../../../components/Badge/StatusBadge";
import { STATUS_WORD, STATUS_WORD_COLOR } from "../../../definitions/QuotaType";
import {
  checkDupPDQuotaDetail,
  checkDupProductQuota,
  checkProductShop,
} from "../../../datasource/ProductQuotaDatasource";
import _ from "lodash";
import { ModalSelectStore } from "../QuotaComponents/ModalSelectStore";
import ConfirmModal from "../../../components/Modal/ConfirmModal";
import InstuctionQuotaConditions from "./InstructionQuotaConditionDup";
import {
  SettingConditionQuotaEachShop,
  SettingConditionQuotaEachShopProduct,
} from "./ModalSettingQuotaCondition";
import RenderSpecialContentDup from "./RenderSpecialContentDup";
import ModalSelectProduct from "../QuotaComponents/ModalSelectProduct";
import dayjs from "dayjs";
import ModalCheckProductDup from "./ModalCheckProductDup";
import ModalCheckQuotaDup from "./ModalCheckQuotaDup";
import { ModalAdjustQuota } from "../StepDup/StepTwoDup";
import { CardContainer } from "../../../components/Card/CardContainer";

const HeadText = styled.div`
  font-size: 14px;
  color: ${color.white};
  font-weight: 700;
`;

export const QuotaCollapseHeaderDup = ({
  product,
  onDeleteProd,
  customStyle,
  isDetail,
  children,
}: {
  product: any;
  onDeleteProd?: (productId: number) => void;
  customStyle?: React.CSSProperties;
  isDetail?: boolean;
  children?: any;
}) => {
  return (
    <div>
      <Row
        style={{
          ...customStyle,
        }}
      >
        <Col span={10}>
          <FlexRow>
            <ProductName product={product} size={84} align='start' />
          </FlexRow>
        </Col>
        <Col span={6}>
          <Text>{product?.productCodeNAV}</Text>
          <br />
          <Text color='Text3' level={6}>
            Pack Size:&nbsp;{product?.packSize}
          </Text>
        </Col>
        <Col span={6}>
          <Text>ราคาปกติ</Text>
          <br />
          <Text>
            {numberFormatter(product.marketPrice, 2)}&nbsp;บาท/
            {product.saleUomTh || product.saleUOMTH}
          </Text>
        </Col>
        {!isDetail && (
          <Col style={{ display: "flex", alignItems: "center", justifyContent: "end" }}>
            <ActionBtnWhite
              onClick={() => !product?.notDelete && onDeleteProd?.(product?.productId)}
              icon={
                <img
                  src={product?.notDelete ? icon.deleteGray : icon.delete}
                  style={{ width: 14, height: 16 }}
                />
              }
            />
          </Col>
        )}
      </Row>
      <br />
      {children}
    </div>
  );
};
export const ShopDetailCollapseDup = ({
  form1,
  form2,
  shopGroupData,
  zoneList,
  dataProduct,
  index,
  isDetail,
  isEditing,
  productId,
}: {
  form1?: FormInstance;
  form2?: any;
  shopGroupData: any[];
  zoneList: any[];
  dataProduct: any;
  index: number;
  isDetail?: boolean;
  isEditing?: boolean;
  productId?: number;
}) => {
  const userCompany = JSON.parse(localStorage.getItem("company")!);
  const dataForm1 = form1?.getFieldsValue(true);
  const getIndex = form2?.getFieldsValue(true).products.findIndex((p) => p.productId === productId);
  const dataForm2 = form2
    ?.getFieldsValue(true)
    .products?.find((p: any) => p.productId === productId);
  const [loadingComponent, setLoadingComponent] = useState(false);
  const [modalSelectStore, setModalSelectStore] = useState<boolean>(false);
  const [modalConfirmDelete, setModalConfirmDelete] = useState(false);
  const [modalIntructCondition, setModalIntructCondition] = useState(false);
  const [modalSettingCondition, setModalSettingCondition] = useState(false);
  const [modalDupProducts, setModalDupProducts] = useState<{
    open: boolean;
    products: any[];
    cusName: string;
  }>({
    open: false,
    products: [],
    cusName: "",
  });
  const [modalDupQuota, setModalDupQuota] = useState<{
    open: boolean;
    quotas: any[];
    cusName: string;
  }>({
    open: false,
    quotas: [],
    cusName: "",
  });
  const [modalAdjustQuota, setModalAdjustQuota] = useState<{
    open: boolean;
    cusData?: any;
    keyNameAdjust?: string;
    keyNameReceive?: string;
  }>({
    open: false,
    cusData: {},
    keyNameAdjust: undefined,
    keyNameReceive: undefined,
  });
  const _watchForm2 = Form.useWatch("products", form2);
  const [dataShopSearch, setDataShopSearch] = useState(dataForm2?.storeList || []);
  const [searchShopName, setSearchShopName] = useState<string | undefined>();
  const [searchShopZone, setSearchShopZone] = useState<string | undefined>();
  const [searchShopGroup, setSearchShopGroup] = useState<string | undefined>();

  const startDate = `${dayjs(dataForm1?.startDate).format("YYYY-MM-DD")} ${dayjs(dataForm1?.startTime).format("HH:mm")}`;
  const endDate = `${dayjs(dataForm1?.endDate).format("YYYY-MM-DD")} ${dayjs(dataForm1?.endTime).format("HH:mm")}`;

  const mapValueStoreList = async () => {
    const product = dataForm2 || {};
    const paramCheckProductQuota: any[] = product?.storeList?.map((p: any) => {
      return {
        customerCompanyId: Number(p.customerCompanyId),
        productId: Number(product.productId),
      };
    });
    const resCheckProQT = await checkDupProductQuota({
      productShop: paramCheckProductQuota,
      quotaId: isEditing || isDetail ? dataForm1?.quotaId : undefined,
      startDate,
      endDate,
    });
    const paramCheckProductShop: any = {
      productId: Number(product.productId),
      customerCompanyId: product?.storeList?.map((s) => Number(s.customerCompanyId)),
    };
    const shopResult: any = await checkProductShop({
      productQuota: paramCheckProductShop,
    });
    const filteredAvilability = shopResult?.filter((product) =>
      dataForm2.products?.some((pid) => `${pid.productId}` === `${product.productId}`),
    );
    const mapStoreError = product?.storeList?.map((item: any, index) => {
      const listCanNotOrder: any[] = [];
      const listCanNotProductQuota: any[] = [];

      if (userCompany.companyType === "Fertilizer") {
        filteredAvilability?.forEach((product) => {
          const canOrder = product?.shopQuota?.some(
            (shop) =>
              `${item.customerCompanyId}` === `${shop.customerCompanyId}` &&
              shop.productShopId !== null &&
              shop.productShopId !== undefined,
          );

          if (!canOrder) {
            listCanNotOrder.push(
              dataForm2.products?.find((p) => `${p.productId}` === `${product.productId}`),
            );
          }
        });
      }

      const proQuota = _.groupBy(
        resCheckProQT?.filter((p) => `${p.customerCompanyId}` === `${item.customerCompanyId}`),
        "customerCompanyId",
      )[`${item.customerCompanyId}`];

      if (proQuota?.length > 0) {
        proQuota?.map((pq) => {
          const find = `${item.customerCompanyId}` === `${pq.customerCompanyId}`;
          if (find) {
            listCanNotProductQuota.push(
              dataForm2.products?.find((p) => `${p.productId}` === `${pq.productId}`),
            );
          }
        });
      }
      if (dataForm1.limitOrderPerDayType === "allShop") {
        form2.setFieldValue(
          `orderPerDay-${product.productId}-${item.customerCompanyId}`,
          dataForm1.countOrder,
        );
      }
      return {
        ...item,
        isCanNotOrderProductList: userCompany.companyType === "Chemical" ? [] : listCanNotOrder,
        isCanNotProductQuotaList: listCanNotProductQuota,
        isCanNotCreate:
          listCanNotOrder.length > 0 || listCanNotProductQuota.length > 0 ? true : false,
      };
    });
    setLoadingComponent(false);
    form2.setFieldValue(["products", getIndex, "storeList"], mapStoreError);
  };

  useEffect(() => {
    if (dataForm2?.storeList?.length > 0) {
      mapValueStoreList();
    }
  }, [_watchForm2, dataForm2, form1, form2]);

  useEffect(() => {
    searchShop();
  }, [searchShopName, searchShopZone, searchShopGroup, _watchForm2]);

  const searchShop = () => {
    if (searchShopName || searchShopZone || searchShopGroup) {
      const dataSearch = dataForm2?.storeList?.filter((s: any) => {
        const searchZone =
          !searchShopZone || searchShopZone === "ALL" || s.zone?.includes(searchShopZone);
        const searchKeyword =
          !searchShopName ||
          s.customerName?.includes(searchShopName) ||
          s.customerNo?.includes(searchShopName.toUpperCase());
        const searchGroup =
          !searchShopGroup ||
          searchShopGroup === "ALL" ||
          (s.customerGroupName || s.customerGroup) === searchShopGroup;
        return searchZone && searchKeyword && searchGroup;
      });

      setDataShopSearch(dataSearch);
    } else {
      setSearchShopName(undefined);
      setSearchShopZone(undefined);
      setSearchShopGroup(undefined);
      setDataShopSearch(dataForm2?.storeList || []);
    }
  };

  const deleteShop = () => {
    const storeList = dataForm2?.storeList || [];
    form2.setFieldValue("deleteShopsInGroup", [
      ...(form2.getFieldValue("deleteShopsInGroup") || []),
      ...(storeList?.filter((s: any) => s.isChecked) || []),
    ]);
    const storeListChecked = storeList?.filter((s: any) => !s.isChecked) || [];
    form2.setFieldValue(["products", getIndex, "storeList"], storeListChecked);

    const _resetShop = storeList
      ?.filter((s: any) => s.isChecked)
      ?.map((item: any) => {
        const keyForm = `${dataProduct.productId}-${item?.customerCompanyId}`;
        form2.setFieldValue(`quotaReceive-${keyForm}`, undefined);
        form2.setFieldValue(`orderPerDay-${keyForm}`, undefined);
      });
  };

  const checkDisableCondition = () => {
    const getListWithShopId =
      dataShopSearch?.filter((s) => (s.shopQuotaId || s.shopTotalQuotaId) && s.isChecked).length ||
      0;
    const getListWithoutShopId =
      dataShopSearch?.filter((s) => (!s.shopQuotaId || !s.shopTotalQuotaId) && s.isChecked)
        .length || 0;
    const countShopChecked = dataShopSearch?.filter((s) => s.isChecked).length || 0;

    return getListWithShopId === countShopChecked
      ? true
      : getListWithoutShopId === countShopChecked
        ? false
        : false;
  };

  const columns = [
    {
      title: (
        <Checkbox
          checked={dataShopSearch?.length > 0 ? dataShopSearch?.every((s) => s.isChecked) : false}
          onClick={(e: any) => {
            const isChecked = e.target.checked;
            const storeList = dataForm2?.storeList || [];
            const mapChecked = storeList.map((item: any) => {
              if (
                (searchShopZone ? item.zone === searchShopZone : true) &&
                (searchShopName
                  ? item.customerName.includes(searchShopName) ||
                    item.customerNo.includes(searchShopName.toUpperCase())
                  : true) &&
                (searchShopGroup ? item.customerGroupName === searchShopGroup : true)
              ) {
                return { ...item, isChecked: isChecked };
              }
              return item;
            });
            form2.setFieldValue(["products", getIndex, "storeList"], mapChecked);
          }}
        />
      ),
      hidden: !dataForm2?.storeList?.length || isDetail,
      dataIndex: "customerNo",
      key: "customerNo",
      render: (value: any, row: any, i: number) => {
        return {
          children: (
            <Checkbox
              checked={row.isChecked}
              onClick={(e: any) => {
                const isChecked = e.target.checked;
                const storeList = dataForm2?.storeList || [];
                const updatedStoreList = storeList.map((item: any) => {
                  if (item.customerCompanyId === row.customerCompanyId) {
                    return {
                      ...item,
                      isChecked: isChecked,
                    };
                  }
                  return item;
                });
                form2.setFieldValue(["products", getIndex, "storeList"], updatedStoreList);
              }}
            />
          ),
        };
      },
    },
    {
      title: "รหัสร้านค้า",
      dataIndex: "customerNo",
      key: "customerNo",
      render: (value: any, row: any, index: number) => {
        return {
          children: <Text>{value}</Text>,
        };
      },
    },
    {
      title: "ชื่อร้านค้า",
      dataIndex: "customerName",
      key: "customerName",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <>
              <Text>{value}</Text>
              <br />
              {row?.isCanNotOrderProductList?.length > 0 &&
                row?.isCanNotOrderProductList?.length < [dataProduct.productId]?.length && (
                  <>
                    <Text fontFamily='Sarabun' fontSize={14} color='warning'>
                      ร้านนี้ไม่มีสินค้าบางรายการจำหน่าย{" "}
                      <strong>{`${row?.isCanNotOrderProductList?.length} รายการ -`}</strong>{" "}
                      <u
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setModalDupProducts({
                            open: true,
                            products: row?.isCanNotOrderProductList || [],
                            cusName: row.customerName,
                          });
                        }}
                      >
                        ดูเพิ่มเติม
                      </u>
                    </Text>
                    <br />
                  </>
                )}
              {row?.isCanNotOrderProductList?.length === [dataProduct.productId]?.length && (
                <>
                  <Text fontFamily='Sarabun' fontSize={14} color='error'>
                    ร้านนี้ไม่มีสินค้าโควตาทั้งหมดจำหน่าย{" "}
                    <strong>(รายการจะถูกลบออกเมื่อบันทึก)</strong>
                  </Text>
                  <br />
                </>
              )}
              {row?.isCanNotProductQuotaList?.length > 0 &&
                row?.isCanNotProductQuotaList?.length < [dataProduct.productId]?.length && (
                  <>
                    <Text fontFamily='Sarabun' level={6} color='warning'>
                      ร้านนี้มีสินค้า{" "}
                      <strong>{`${row?.isCanNotProductQuotaList?.length} รายการ `}</strong>
                      เข้าร่วมกับโควตาอื่น -{" "}
                      <u
                        style={{ cursor: "pointer" }}
                        onClick={async () => {
                          const mapParam = row.isCanNotProductQuotaList?.map((p: any) => {
                            return {
                              productId: p.productId,
                              customerCompanyId: row.customerCompanyId,
                            };
                          });
                          const getDetail = await checkDupPDQuotaDetail({
                            productShop: mapParam,
                            quotaId: isEditing || isDetail ? dataForm1?.quotaId : undefined,
                            startDate,
                            endDate,
                          });
                          setModalDupQuota({
                            open: true,
                            quotas: getDetail || [],
                            cusName: row.customerName,
                          });
                        }}
                      >
                        ดูเพิ่มเติม
                      </u>
                    </Text>
                    <br />
                  </>
                )}
              {row?.isCanNotProductQuotaList?.length === [dataProduct.productId]?.length && (
                <>
                  <Text fontFamily='Sarabun' fontSize={14} color='error'>
                    ร้านนี้มีสินค้าทั้งหมดเข้าร่วมกับโควตาอื่น{" "}
                    <strong>(รายการจะถูกลบออกเมื่อบันทึก)</strong>
                  </Text>
                  <br />
                </>
              )}
            </>
          ),
        };
      },
    },
    {
      title: "ประเภทคู่ค้า",
      dataIndex: "dealerType",
      key: "dealerType",
      width: 130,
      render: (value: any, row: any, index: number) => {
        return {
          children: <Text level={6}>{dealerTypeName["DEALER"]}</Text>,
        };
      },
    },
    {
      title: "เขต",
      dataIndex: "zone",
      key: "zone",
      render: (value: any, row: any, index: number) => {
        return {
          children: <Text>{value}</Text>,
        };
      },
    },
    {
      title: "กลุ่มลูกค้า",
      dataIndex: "customerGroupName",
      key: "customerGroupName",
      width: 170,
      render: (value: any, row: any, index: number) => {
        return {
          children: <Text>{value || row.customerGroup || "-"}</Text>,
        };
      },
    },
    {
      title: "โควตาถูกใช้ / ทั้งหมด",
      dataIndex: "quotaUsed",
      key: "quotaUsed",
      hidden: !isDetail && !isEditing,
      width: 180,
      render: (value: any, row: any, index: number) => {
        const { quotaUsed, saleUomTh } = row;
        const keyName = `quotaReceive-${dataProduct.productId}-${row.customerCompanyId}`;
        const quotaReceive = form2.getFieldValue(keyName) || 0;
        const percent = quotaReceive > 0 ? (quotaUsed * 100) / quotaReceive : 0;
        return (
          <>
            {row.shopQuotaId ? (
              <FlexCol>
                <Text>
                  {numberFormatter(quotaUsed || 0, 2)}&nbsp;/&nbsp;
                  {numberFormatter(quotaReceive || 0, 2)}
                  &nbsp;{saleUomTh}
                </Text>
                <Progress percent={percent} showInfo={false} />
              </FlexCol>
            ) : (
              <>
                {row?.isCanNotProductQuotaList?.length === [dataProduct.productId]?.length ||
                row?.isCanNotOrderProductList?.length === [dataProduct.productId]?.length ? (
                  <></>
                ) : (
                  <Form.Item
                    name={keyName}
                    rules={[{ required: true, message: "โปรดระบุโควตา" }]}
                    style={{ marginBottom: 0 }}
                  >
                    <Input
                      autoComplete='off'
                      placeholder='ระบุจำนวนโควตา'
                      suffix={
                        <>
                          {userCompany?.companyType === "Chemical" ? (
                            <Text fontFamily='Sarabun' fontSize={14}>
                              ลัง/กระสอบ
                            </Text>
                          ) : (
                            <Text fontFamily='Sarabun' fontSize={14}>
                              ตัน
                            </Text>
                          )}
                        </>
                      }
                      onKeyDown={handleNumberOnlyCopyPaste}
                      disabled={isDetail}
                      style={{ color: color.BK }}
                    />
                  </Form.Item>
                )}
              </>
            )}
          </>
        );
      },
    },
    {
      title: (
        <>
          <Text color='white' fontSize={14} fontWeight={700}>
            กำหนดโควตา
          </Text>
          <span style={{ color: color.error }}>*</span>
        </>
      ),
      dataIndex: "customerCompanyId",
      key: "quotaReceive",
      width: 250,
      hidden: isDetail || isEditing,
      render: (customerCompanyId: any, row: any, index: number) => {
        const keyName = `quotaReceive-${dataProduct.productId}-${row.customerCompanyId}`;
        return (
          <>
            {row?.isCanNotProductQuotaList?.length === [dataProduct.productId]?.length ||
            row?.isCanNotOrderProductList?.length === [dataProduct.productId]?.length ? (
              <></>
            ) : (
              <Form.Item
                name={keyName}
                rules={[{ required: true, message: "โปรดระบุโควตา" }]}
                style={{ marginBottom: 0 }}
              >
                <Input
                  autoComplete='off'
                  placeholder='ระบุจำนวนโควตา'
                  suffix={
                    <>
                      {userCompany?.companyType === "Chemical" ? (
                        <Text fontFamily='Sarabun' fontSize={14}>
                          ลัง/กระสอบ
                        </Text>
                      ) : (
                        <Text fontFamily='Sarabun' fontSize={14}>
                          ตัน
                        </Text>
                      )}
                    </>
                  }
                  onKeyDown={handleNumberOnlyCopyPaste}
                  disabled={isDetail}
                  style={{ color: color.BK }}
                />
              </Form.Item>
            )}
          </>
        );
      },
    },
    {
      title: (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Text
            color='white'
            fontSize={13}
            fontWeight={600}
            lineHeight={20}
            style={{ display: "block", marginBottom: 4 }}
          >
            จำกัดคำสั่งซื้อ / วัน
            <span style={{ color: color.error }}>*</span>
          </Text>
          <Text
            style={{ display: "block" }}
            color='warning'
            fontSize={12}
            fontWeight={600}
            lineHeight={2}
          >
            แบบนับรวมทุกสินค้า
          </Text>
        </div>
      ),
      dataIndex: "limitOrders",
      key: "limitOrders",
      width: 200,
      hidden: !dataForm1.limitOrderDay,
      render: (_: any, row: any, index: number) => {
        const keyName = `orderPerDay-${dataProduct.productId}-${row.customerCompanyId}`;
        return (
          <>
            {row?.isCanNotProductQuotaList?.length === [dataProduct.productId]?.length ||
            row?.isCanNotOrderProductList?.length === [dataProduct.productId]?.length ? (
              <></>
            ) : (
              <Form.Item
                name={keyName}
                rules={[{ required: true, message: "โปรดระบุจำนวนคำสั่งซื้อ" }]}
              >
                <Input
                  style={{ color: color.BK }}
                  disabled={dataForm1.limitOrderPerDayType === "allShop" || isDetail}
                  placeholder='ระบุจำนวน'
                  suffix={
                    <Text fontFamily='Sarabun' fontSize={14}>
                      ครั้ง / วัน
                    </Text>
                  }
                  onKeyDown={handleNumberOnlyCopyPaste}
                  autoComplete='off'
                />
              </Form.Item>
            )}
          </>
        );
      },
    },
    {
      title: "โควตาแก้ไข",
      dataIndex: "customerCompanyId",
      key: "edit",
      width: 120,
      hidden: isDetail || !isEditing,
      render: (_: any, record: any) => {
        const keyNameAdjust = `adjustQuota-${dataProduct.productId}-${record.customerCompanyId}`;
        const getValueAdjust = form2.getFieldValue(keyNameAdjust);
        const unit = userCompany.companyCode === "ICPL" ? "ลัง" : "ตัน";
        if (record.shopQuotaId) {
          if (getValueAdjust) {
            const isPositive = getValueAdjust > 0;
            return (
              <FlexRow align='center'>
                <Text color={isPositive ? "success" : "error"}>
                  {isPositive ? "+" : "-"} {Math.abs(getValueAdjust)} {unit}
                </Text>
                &nbsp;&nbsp;&nbsp;
                <CloseOutlined
                  style={{ fontSize: 10, fontWeight: 700, cursor: "pointer" }}
                  onClick={() => {
                    form2.setFieldValue(keyNameAdjust, null);
                    form2.setFieldValue(
                      `quotaReceive-${dataProduct.productId}-${record.customerCompanyId}`,
                      record.quotaReceive,
                    );
                    form2.setFieldValue("products", form2.getFieldValue("products"));
                  }}
                />
              </FlexRow>
            );
          }
          return (
            <Button
              title='เพิ่ม/ลดโควตา'
              typeButton='primary-light'
              onClick={() =>
                setModalAdjustQuota({
                  open: true,
                  cusData: record,
                  keyNameAdjust: `adjustQuota-${dataProduct.productId}-${record.customerCompanyId}`,
                  keyNameReceive: `quotaReceive-${dataProduct.productId}-${record.customerCompanyId}`,
                })
              }
            />
          );
        } else {
          return <></>;
        }
      },
    },
    {
      title: "สถานะใช้งาน",
      dataIndex: "isActive",
      key: "isActive",
      width: 130,
      hidden: isEditing && !isDetail,
      render: (value: any, row: any, index: number) => {
        return (
          <>
            {row?.isCanNotProductQuotaList?.length === [dataProduct.productId]?.length ||
            row?.isCanNotOrderProductList?.length === [dataProduct.productId]?.length ? (
              <></>
            ) : (
              <StatusBadge
                key={index}
                label={STATUS_WORD[value]}
                bgColor={STATUS_WORD_COLOR[value]}
                borderRadius='20px'
              />
            )}
          </>
        );
      },
    },
    {
      title: "เปิด/ปิดรายร้าน",
      dataIndex: "oldIsActive",
      key: "oldIsActive",
      width: 130,
      hidden: !isEditing,
      render: (value: any, row: any, i: number) => {
        return (
          <>
            {row.shopQuotaId ? (
              <Switch
                defaultChecked={!!value}
                onChange={(checked) => {
                  form2.setFieldValue(["products", index, "storeList", i, "isActive"], checked);
                }}
                checkedChildren={"เปิดใช้งาน"}
                unCheckedChildren='ปิดใช้งาน'
              />
            ) : (
              <>
                {row?.isCanNotProductQuotaList?.length === [dataProduct.productId]?.length ||
                row?.isCanNotOrderProductList?.length === [dataProduct.productId]?.length ? (
                  <></>
                ) : (
                  <StatusBadge
                    key={index}
                    label={STATUS_WORD[value]}
                    bgColor={STATUS_WORD_COLOR[value]}
                    borderRadius='20px'
                  />
                )}
              </>
            )}
          </>
        );
      },
    },
  ].filter((col) => !col.hidden);

  return (
    <>
      <div
        style={{
          margin: "-16px",
          padding: "16px",
          borderBottomRightRadius: "8px",
          borderBottomLeftRadius: "8px",
          backgroundColor: "#BABCBE",
        }}
      >
        <Row gutter={6} style={{ marginBottom: 12 }} justify='start'>
          <Col span={8}>
            <Input
              allowClear
              placeholder='ค้นหารหัส/ชื่อร้าน'
              suffix={<SearchOutlined />}
              onPressEnter={(e: any) => setSearchShopName(e.target.value)}
            />
          </Col>
          <Col span={4}>
            <Select
              placeholder='เขตทั้งหมด'
              fontWeight={400}
              data={zoneList || []}
              value={searchShopZone || "ALL"}
              style={{ width: "100%" }}
              onChange={(e) => {
                if (e) {
                  setSearchShopZone(e);
                } else {
                  setSearchShopZone("ALL");
                }
              }}
            />
          </Col>
          <Col span={4}>
            <Select
              placeholder='กลุ่มลูกค้าทั้งหมด'
              fontWeight={400}
              value={searchShopGroup || "ALL"}
              data={shopGroupData}
              onChange={(e) => {
                if (e) {
                  setSearchShopGroup(e);
                } else {
                  setSearchShopGroup("ALL");
                }
              }}
              style={{ width: "100%" }}
            />
          </Col>
          <Col span={2} />
          {!isDetail && (
            <Col span={6}>
              <Row justify={"end"} gutter={6}>
                <Col>
                  <Button
                    title='ลบร้านค้า'
                    icon={
                      <img
                        src={
                          dataProduct?.storeList?.filter((s) => s.isChecked)?.length
                            ? icon.deleteWhite
                            : icon.deleteGray
                        }
                        style={{ width: 16, height: 16 }}
                      />
                    }
                    typeButton={
                      dataProduct?.storeList?.filter((s) => s.isChecked)?.length
                        ? "danger"
                        : "light-disabled"
                    }
                    disabled={dataProduct?.storeList?.filter((s) => s.isChecked)?.length === 0}
                    onClick={() => {
                      setModalConfirmDelete(true);
                    }}
                    style={{ width: "max-content" }}
                  />
                </Col>
                <Col>
                  <Button
                    onClick={() => setModalSelectStore(true)}
                    title='เพิ่มร้านค้า'
                    icon={<PlusOutlined />}
                    style={{ width: "max-content" }}
                  />
                </Col>
              </Row>
            </Col>
          )}
        </Row>
        <Row gutter={[10, 10]} style={{ marginBottom: 12 }} justify='end'>
          {[
            {
              icon: <ScanOutlined style={{ fontSize: "18px" }} />,
              title: "เพิ่มเงื่อนไขเดียวกัน",
            },
            // {
            //   icon: <UploadOutlined />,
            //   title: "Export & Import",
            //   //onClick: () => isOpenExport?.(true),
            // },
          ].map((btn, idx) => (
            <>
              <Col style={{ paddingTop: "8px" }}>
                <Text>{`จำนวน ${numberFormatter(dataForm2?.storeList?.length || 0, 0)} ร้านค้า`}</Text>
              </Col>
              {!isDetail && (
                <Col
                  key={idx}
                  xs='auto'
                  sm='auto'
                  md='auto'
                  lg='auto'
                  xl='auto'
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Button
                    onClick={() =>
                      dataForm2?.storeList?.filter((s) => s.isChecked).length > 0
                        ? checkDisableCondition()
                          ? undefined
                          : setModalSettingCondition(true)
                        : setModalIntructCondition(true)
                    }
                    style={{ width: "max-content" }}
                    icon={btn.icon}
                    title={btn.title}
                    typeButton={
                      dataForm2?.storeList?.filter((s) => s.isChecked).length === 0
                        ? "border-primary"
                        : checkDisableCondition()
                          ? "light-disabled"
                          : "border-primary"
                    }
                  />
                </Col>
              )}
            </>
          ))}
        </Row>
        <TableContainer>
          {loadingComponent ? (
            <CardContainer>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "30vh",
                }}
              >
                <Spin />
              </div>
            </CardContainer>
          ) : (
            <Form.Item name={"products"} noStyle>
              <Table
                columns={columns}
                dataSource={dataShopSearch || []}
                scroll={{
                  x: dataShopSearch?.length > 0 ? "max-content" : 0,
                  y: 520,
                }}
                pagination={false}
              />
            </Form.Item>
          )}
        </TableContainer>
      </div>
      {modalSelectStore && (
        <ModalSelectStore
          showModalShop
          excludeCusCompanyId={dataForm2?.storeList?.map((s) => s.customerCompanyId) || []}
          callBackShop={(stores) => {
            form2.setFieldValue(
              ["products", getIndex, "storeList"],
              [
                ...(dataForm2?.storeList || []),
                ...stores.map((s) => ({
                  ...s,
                  shopQuotaId: undefined,
                  oldIsActive: true,
                  isChecked: false,
                })),
              ],
            );
            setModalSelectStore(false);
          }}
          currentSelectShop={dataProduct?.storeList || []}
          company={userCompany.companyCode}
          onClose={() => {
            setModalSelectStore(false);
          }}
          customerType='DL'
          replaceSaveButtonTitle='บันทึก'
          replaceTitle={
            <FlexCol>
              <Text level={4} fontWeight={700}>
                เพิ่มร้านค้าและสินค้า
              </Text>
              <br />
              <FlexRow align='end'>
                <Text color='Text3' level={6}>
                  เลือกได้มากกว่า 1 ร้านค้า
                </Text>
              </FlexRow>
            </FlexCol>
          }
          hideCurrect
        />
      )}
      {modalConfirmDelete && (
        <ConfirmModal
          visible={modalConfirmDelete}
          onConfirm={() => {
            deleteShop();
            setModalConfirmDelete(false);
          }}
          onCancel={() => {
            setModalConfirmDelete(false);
          }}
          typeButtonSubmit='danger'
          typeButtonCancel='border-danger'
          title={`ต้องการลบร้านค้า ${form2.getFieldValue(["products", index, "storeList"]).filter((s) => s.isChecked).length} รายการ`}
          desc='โปรดตรวจสอบรายละเอียดอีกครั้งก่อนการกดยืนยัน เพราะอาจส่งผลต่อข้อมูลร้านค้าในระบบ'
        />
      )}
      {modalIntructCondition && (
        <InstuctionQuotaConditions
          open={modalIntructCondition}
          onClose={() => setModalIntructCondition(false)}
        />
      )}
      {modalSettingCondition && (
        <SettingConditionQuotaEachShop
          open={modalSettingCondition}
          onClose={() => setModalSettingCondition(false)}
          onSubmit={(q, l, conditionType) => {
            setLoadingComponent(true);
            const findValue = form2.getFieldValue(["products", index, "storeList"]);
            const mapValue = findValue?.map((item) => {
              const keyForm = `${dataProduct.productId}-${item?.customerCompanyId}`;
              if (item.isChecked) {
                form2.setFieldValue(
                  `quotaReceive-${keyForm}`,
                  conditionType.includes("quota")
                    ? q
                    : form2.getFieldValue(`quotaReceive-${keyForm}`) || null,
                );
                form2.setFieldValue(
                  `orderPerDay-${keyForm}`,
                  conditionType.includes("limit")
                    ? l
                    : form2.getFieldValue(`orderPerDay-${keyForm}`) || null,
                );
                return {
                  ...item,
                  isChecked: false,
                };
              }
              return item;
            });
            form2.setFieldValue(["products", index, "storeList"], mapValue);
            setModalSettingCondition(false);
            setTimeout(() => {
              setLoadingComponent(false);
            }, 400);
          }}
          showQuota={dataForm1.quotaType !== "QUOTA_TOTAL"}
          showLimit={dataForm1.limitOrderDay}
          typeLimitQuota={dataForm1.limitOrderPerDayType}
          countOrder={dataForm1.countOrder}
        />
      )}
      {modalDupProducts.open && (
        <ModalCheckProductDup
          visible={modalDupProducts.open}
          onCancel={() => setModalDupProducts({ open: false, products: [], cusName: "" })}
          products={modalDupProducts?.products}
          cusName={modalDupProducts?.cusName}
        />
      )}
      {modalDupQuota.open && (
        <ModalCheckQuotaDup
          open={modalDupQuota.open}
          onCancel={() => setModalDupQuota({ open: false, quotas: [], cusName: "" })}
          datas={modalDupQuota?.quotas}
          cusName={modalDupQuota?.cusName}
        />
      )}
      {modalAdjustQuota.open && (
        <ModalAdjustQuota
          open={modalAdjustQuota.open}
          setOpen={(value) => setModalAdjustQuota({ ...modalAdjustQuota, open: value })}
          cusData={modalAdjustQuota?.cusData}
          keyNameAdjust={modalAdjustQuota?.keyNameAdjust}
          keyNameReceive={modalAdjustQuota?.keyNameReceive}
          onSubmit={(value, keyNameAdjust, keyNameReceive) => {
            const quotaCurrent = form2.getFieldValue(keyNameReceive);
            if (Number(value.adjustType) < 0) {
              form2.setFieldValue(keyNameReceive, quotaCurrent - Number(value.adjustValue));
            } else {
              form2.setFieldValue(keyNameReceive, quotaCurrent + Number(value.adjustValue));
            }
            form2.setFieldValue(
              keyNameAdjust,
              Number(value.adjustValue) * Number(value.adjustType),
            );
            setModalAdjustQuota({ open: false, cusData: {} });
          }}
        />
      )}
    </>
  );
};

//#region Quota Group
export const QuotaGroupCollapseHeaderDup = ({
  form1,
  form2,
  groupIndex,
  onDeleteGroup,
  isDetail,
  groupNo,
  productSelected,
}: {
  form1?: FormInstance;
  form2?: any;
  groupIndex: number;
  onDeleteGroup?: (groupIndex: number) => void;
  isDetail?: boolean;
  groupNo?: number;
  productSelected?: any[];
}) => {
  const userProfile = JSON.parse(localStorage.getItem("profile")!);
  const company = JSON.parse(localStorage.getItem("company")!);
  const form1Values = form1?.getFieldsValue(true);
  const form2Values = form2?.getFieldsValue(true).products?.find((p) => p?.groupNo === groupNo);
  const _watchForm2 = Form.useWatch([], form2);
  const [modalSettingCondition, setModalSettingCondition] = useState(false);
  const [modalSelectProduct, setModalSelectProduct] = useState(false);

  const calQuotaReceive = () => {
    let quotaReceive = 0;
    form2Values?.storeList?.forEach((s) => {
      const keyForm = `quotaReceive-${s.customerCompanyId}-${groupNo}`;
      const value = form2.getFieldValue(keyForm);
      quotaReceive += Number(value) || 0;
    });
    return quotaReceive;
  };
  const calQuotaUsed = () => {
    let quotaUsed = 0;
    form2Values?.storeList?.forEach((s) => {
      quotaUsed += Number(s.quotaUsed) || 0;
    });
    return quotaUsed;
  };
  const checkNotDelete = () => {
    const checkProductDelete = form2Values?.productList?.some((p) => p.notDelete);
    const checkShopDelete = form2Values?.storeList?.some((s) => s.notDelete);
    return checkProductDelete || checkShopDelete;
  };

  return (
    <>
      <Row
        justify='space-between'
        align='middle'
        style={{
          padding: "14px",
          flexWrap: "wrap",
        }}
      >
        <Col>
          <Text fontWeight={700} color='white'>
            สินค้ากลุ่มที่ {groupNo || groupIndex + 1}
          </Text>
        </Col>
        <Col>
          <Row gutter={[16, 8]} justify='end' align='middle' style={{ flexWrap: "wrap" }}>
            <Col>
              <img
                src={icon.ProductsBoxWhite}
                alt='quota icon'
                style={{ width: 22, height: 22, marginRight: 8 }}
              />
              <Text fontSize={14} color='white'>
                <HeadText style={{ display: "inline", marginRight: 4 }}>
                  {form2Values?.productList?.length || 0}
                </HeadText>
                สินค้า
              </Text>
            </Col>
            <Col>
              <img
                src={icon.manage_shop}
                alt='shop icon'
                style={{ width: 22, height: 22, marginRight: 8 }}
              />
              <Text fontSize={14} color='white'>
                <HeadText style={{ display: "inline", marginRight: 4 }}>
                  {numberFormatter(form2Values?.storeList?.length || 0, 0)}
                </HeadText>
                ร้าน
              </Text>
            </Col>
            <Col>
              <img
                src={icon.productQuota_active}
                alt='quota icon'
                style={{ width: 22, height: 22, marginRight: 8 }}
              />
              <Text fontSize={14} color='white'>
                โควตาถูกใช้
                <HeadText style={{ display: "inline", margin: "0 4px" }}>
                  <>
                    {numberFormatter(calQuotaUsed(), 2)} / {numberFormatter(calQuotaReceive(), 2)}
                  </>
                </HeadText>
                {userProfile?.company === "ICPL" ? "ลัง" : "ตัน"}
              </Text>
            </Col>
            {!isDetail && (
              <>
                {!checkNotDelete() && (
                  <Col>
                    <Button
                      title='ลบกลุ่ม'
                      textStyle={{ color: "white", fontSize: 14 }}
                      typeButton={"border-light"}
                      style={{ width: "max-content" }}
                      onClick={() => onDeleteGroup?.(groupIndex)}
                    />
                  </Col>
                )}

                <Col>
                  <Button
                    title='+ เพิ่มสินค้า'
                    textStyle={{ color: "white", fontSize: 14 }}
                    typeButton='border-light'
                    style={{ width: "max-content" }}
                    onClick={() => setModalSelectProduct(true)}
                  />
                </Col>
                <Col>
                  <Button
                    title='เพิ่มเงื่อนไขเดียวกันสินค้า'
                    icon={<ScanOutlined style={{ color: "white" }} />}
                    textStyle={{ color: "white", fontSize: 14 }}
                    typeButton='border-light'
                    style={{ width: "max-content" }}
                    onClick={() => setModalSettingCondition(true)}
                  />
                </Col>
              </>
            )}
          </Row>
        </Col>
      </Row>
      {modalSettingCondition && (
        <SettingConditionQuotaEachShopProduct
          open={modalSettingCondition}
          onClose={() => setModalSettingCondition(false)}
          isSpecialPrice={form1Values.quotaShopPrice === "SPECIAL_PRICE"}
          isLimitOrder={form1Values.limitQuantityOrder}
          onSubmit={(s, l, conditionType) => {
            const mapProduct = form2Values || [];
            mapProduct?.productList?.map((p) => {
              const keySpecialPrice = `specialPrice-${p.productId}`;
              const keyLimitQty = `limitQty-${p.productId}`;
              if (conditionType.includes("specialPrice")) {
                form2.setFieldValue(keySpecialPrice, s);
              }
              if (conditionType.includes("limitOrder")) {
                form2.setFieldValue(keyLimitQty, l);
              }
            });
            setModalSettingCondition(false);
          }}
        />
      )}
      {modalSelectProduct && (
        <Modal open={modalSelectProduct} width={1350} closable={false} footer={null}>
          <ModalSelectProduct
            list={productSelected || []}
            setList={(products) => {
              const mapProductList: any = products?.map((item) => {
                return {
                  productId: item.productId,
                  productImage: item.productImage,
                  productName: item.productName,
                  saleUOM: item.saleUOM,
                  saleUOMTH: item.saleUOMTH,
                  company: item.company,
                  commonName: item.commonName,
                  productBrandId: item.productBrandId,
                  productBrandName: item.productBrandName,
                  productStatus: item.productStatus,
                  marketPrice: item.marketPrice,
                  discount: null,
                  orderLimit: null,
                  productQuotaId: null,
                  productQuotaGroupId: null,
                  quotaUse: 0,
                  packSize: item.packSize,
                  notDelete: false,
                };
              });

              const mapGroup = {
                groupNo: groupNo,
                productList: [...(form2Values?.productList || []), ...mapProductList],
                storeList: form2Values?.storeList,
              };

              form2.setFieldValue(["products", Number(groupNo) - 1], mapGroup);
              setModalSelectProduct(false);
            }}
            withBackButton={{ title: "ย้อนกลับ", onBack: () => setModalSelectProduct(false) }}
            customTitle={
              <Text level={4} fontWeight={700}>
                เพิ่มสินค้า
              </Text>
            }
          />
        </Modal>
      )}
    </>
  );
};
export const QuotaGroupProductHeaderDup = ({
  product,
  onDeleteProd,
  customStyle,
  isCondition,
  form2,
  isDetail,
}: {
  product: any;
  onDeleteProd?: (productId: number) => void;
  customStyle?: React.CSSProperties;
  isCondition?: any;
  form2: FormInstance;
  isDetail?: boolean;
}) => {
  return (
    <div>
      <Row
        style={{
          ...customStyle,
        }}
      >
        <Col span={10}>
          <FlexRow>
            <ProductName product={product} size={84} align='start' />
          </FlexRow>
        </Col>
        <Col span={6}>
          <Text>{product?.productCodeNAV}</Text>
          <br />
          <Text color='Text3' level={6}>
            Pack Size:&nbsp;{product?.packSize}
          </Text>
        </Col>
        <Col span={6}>
          <Text>ราคาปกติ</Text>
          <br />
          <Text>
            {numberFormatter(product.marketPrice, 2)}&nbsp;บาท/
            {product.saleUomTh || product.saleUOMTH || "-"}
          </Text>
        </Col>
        {!isDetail && (
          <Col style={{ display: "flex", alignItems: "center", justifyContent: "end" }}>
            <ActionBtnWhite
              onClick={() => !product?.notDelete && onDeleteProd?.(product?.productId)}
              icon={
                <img
                  src={product?.notDelete ? icon.deleteGray : icon.delete}
                  style={{ width: 14, height: 16 }}
                />
              }
            />
          </Col>
        )}
      </Row>

      {isCondition.isShowCondition && (
        <RenderSpecialContentDup
          isSpecial={isCondition.isSpecialPrice}
          isLimitedOrder={isCondition.isLimitOrder}
          marketPrice={product.marketPrice}
          saleUOMTH={product.saleUomTh || product.saleUOMTH || "-"}
          keyNameLimitQty={`limitQty-${product.productId}`}
          keyNameSpecialPrice={`specialPrice-${product.productId}`}
          isDetail={isDetail}
          form2={form2}
        />
      )}
    </div>
  );
};
export const QuotaGroupShopDetailCollapseDup = ({
  form1,
  form2,
  shopGroupData,
  zoneList,
  dataProduct,
  groupIndex,
  isDetail,
  isEditing,
  groupNo,
  shopList,
  searchProduct,
}: {
  form1?: FormInstance;
  form2?: any;
  shopGroupData: any[];
  zoneList: any[];
  dataProduct: any;
  groupIndex: number;
  isDetail?: boolean;
  isEditing?: boolean;
  groupNo?: number;
  shopList?: any[];
  searchProduct?: string;
}) => {
  const userCompany = JSON.parse(localStorage.getItem("company")!);
  const dataForm1 = form1?.getFieldsValue(true);
  const dataForm2 =
    form2?.getFieldsValue(true).products?.find((p: any, i: number) => p?.groupNo === groupNo) || {};
  const [loadingComponent, setLoadingComponent] = useState(false);
  const [modalSelectStore, setModalSelectStore] = useState<boolean>(false);
  const [modalConfirmDelete, setModalConfirmDelete] = useState(false);
  const [modalIntructCondition, setModalIntructCondition] = useState(false);
  const [modalSettingCondition, setModalSettingCondition] = useState(false);
  const [modalDupProducts, setModalDupProducts] = useState<{
    open: boolean;
    products: any[];
    cusName: string;
  }>({
    open: false,
    products: [],
    cusName: "",
  });
  const [modalDupQuota, setModalDupQuota] = useState<{
    open: boolean;
    quotas: any[];
    cusName: string;
  }>({
    open: false,
    quotas: [],
    cusName: "",
  });
  const [modalAdjustQuota, setModalAdjustQuota] = useState<{
    open: boolean;
    cusData?: any;
    keyNameAdjust?: string;
    keyNameReceive?: string;
  }>({
    open: false,
    cusData: {},
    keyNameAdjust: undefined,
    keyNameReceive: undefined,
  });
  const _watchForm2 = Form.useWatch("products", form2);
  const [dataShopSearch, setDataShopSearch] = useState(shopList || []);
  const [searchShopName, setSearchShopName] = useState<string | undefined>(undefined);
  const [searchShopZone, setSearchShopZone] = useState<string | undefined>(undefined);
  const [searchShopGroup, setSearchShopGroup] = useState<string | undefined>(undefined);

  const startDate = `${dayjs(dataForm1?.startDate).format("YYYY-MM-DD")} ${dayjs(dataForm1?.startTime).format("HH:mm")}`;
  const endDate = `${dayjs(dataForm1?.endDate).format("YYYY-MM-DD")} ${dayjs(dataForm1?.endTime).format("HH:mm")}`;

  const mapValueStoreList = async () => {
    const paramCheckProductQuota: any[] = [];
    dataProduct?.map((product) => {
      dataForm2?.storeList?.forEach((p: any) => {
        paramCheckProductQuota.push({
          customerCompanyId: Number(p.customerCompanyId),
          productId: Number(product.productId),
        });
      });
    });

    const resCheckProQT = await checkDupProductQuota({
      productShop: paramCheckProductQuota,
      quotaId: isEditing || isDetail ? dataForm1?.quotaId : undefined,
      startDate,
      endDate,
    });

    const paramCheckProductShop: any = dataProduct?.map((product) => {
      return {
        productId: Number(product.productId),
        customerCompanyId: dataForm2?.storeList?.map((s) => Number(s.customerCompanyId)),
      };
    });

    const shopResult: any = await checkProductShop({
      productQuota: paramCheckProductShop,
    });
    const filteredAvilability = (shopResult || [])?.filter((product) =>
      dataForm2.productList?.some((pid) => `${pid.productId}` === `${product.productId}`),
    );
    const mapStoreError = dataForm2?.storeList?.map((item: any, index) => {
      const listCanNotOrder: any[] = [];
      const listCanNotProductQuota: any[] = [];
      if (userCompany.companyType === "Fertilizer") {
        filteredAvilability?.forEach((product) => {
          const canOrder = product?.shopQuota?.some(
            (shop) =>
              `${item.customerCompanyId}` === `${shop.customerCompanyId}` &&
              shop.productShopId !== null &&
              shop.productShopId !== undefined,
          );

          if (!canOrder) {
            listCanNotOrder.push(
              dataProduct?.find((p) => `${p.productId}` === `${product.productId}`),
            );
          }
        });
      }

      const proQuota = _.groupBy(
        resCheckProQT?.filter((p) => `${p.customerCompanyId}` === `${item.customerCompanyId}`),
        "customerCompanyId",
      )[`${item.customerCompanyId}`];

      if (proQuota?.length > 0) {
        proQuota?.map((pq) => {
          const find = `${item.customerCompanyId}` === `${pq.customerCompanyId}`;
          if (find) {
            listCanNotProductQuota.push(
              dataProduct?.find((p) => `${p.productId}` === `${pq.productId}`),
            );
          }
        });
      }
      if (dataForm1.limitOrderPerDayType === "allShop") {
        form2.setFieldValue(
          `orderPerDay-${item.customerCompanyId}-${groupNo}`,
          dataForm1.countOrder,
        );
      }
      return {
        ...item,
        isCanNotOrderProductList: userCompany.companyType === "Chemical" ? [] : listCanNotOrder,
        isCanNotProductQuotaList: listCanNotProductQuota,
        isCanNotCreate:
          listCanNotOrder.length === dataProduct.length ||
          listCanNotProductQuota.length === dataProduct.length
            ? true
            : false,
      };
    });
    form2.setFieldValue(["products", (groupNo || 0) - 1, "storeList"], mapStoreError);
  };

  useEffect(() => {
    if (dataForm2?.storeList?.length > 0) {
      mapValueStoreList();
    }
  }, [_watchForm2, dataForm2, form1, form2, dataForm1]);

  useEffect(() => {
    searchShop();
  }, [searchShopName, searchShopZone, searchShopGroup, searchProduct, _watchForm2]);

  const searchShop = () => {
    if (searchShopName || searchShopZone || searchShopGroup || searchProduct) {
      const getDataGroup = form2
        ?.getFieldValue(["products"])
        ?.find((g: any, i: number) => g.groupNo === groupNo);
      const dataSearch = getDataGroup?.storeList?.filter((s: any) => {
        const searchZone =
          !searchShopZone || searchShopZone === "ALL" || s.zone?.includes(searchShopZone);
        const searchKeyword =
          !searchShopName ||
          s.customerName?.includes(searchShopName) ||
          s.customerNo?.includes(searchShopName.toUpperCase());
        const searchGroup =
          !searchShopGroup ||
          searchShopGroup === "ALL" ||
          (s.customerGroupName || s.customerGroup) === searchShopGroup;
        return searchZone && searchKeyword && searchGroup;
      });
      setDataShopSearch(dataSearch);
    } else {
      setSearchShopGroup(undefined);
      setSearchShopZone(undefined);
      setSearchShopName(undefined);
      setDataShopSearch(dataForm2.storeList || []);
    }
  };
  const deleteShop = () => {
    const storeList = form2.getFieldValue(["products", (groupNo || 0) - 1, "storeList"]) || [];
    const storeListChecked =
      storeList?.filter((s: any) => s.isChecked && Number(s.quotaUsed) <= 0) || [];
    form2.setFieldValue("deleteShopsInGroup", [
      ...(form2.getFieldValue("deleteShopsInGroup") || []),
      ...storeListChecked,
    ]);
    const storeListUnchecked =
      storeList
        ?.filter((s: any) => !s.isChecked || Number(s.quotaUsed) > 0)
        .map((item: any) => ({ ...item, isChecked: false })) || [];
    form2.setFieldValue(["products", (groupNo || 0) - 1, "storeList"], storeListUnchecked);

    const _resetShop = storeList
      ?.filter((s: any) => s.isChecked && Number(s.quotaUsed) <= 0)
      ?.map((item: any) => {
        const keyForm = `${item?.customerCompanyId}-${groupNo}`;
        form2.setFieldValue(`quotaReceive-${keyForm}`, undefined);
        form2.setFieldValue(`orderPerDay-${keyForm}`, undefined);
      });
  };
  const checkDisableCondition = () => {
    const getListWithShopId =
      dataShopSearch?.filter((s) => s.shopTotalQuotaId && s.isChecked).length || 0;
    const getListWithoutShopId =
      dataShopSearch?.filter((s) => !s.shopTotalQuotaId && s.isChecked).length || 0;
    const countShopChecked = dataShopSearch?.filter((s) => s.isChecked).length || 0;

    return dataForm1.limitOrderDay && !dataForm1.allShop
      ? false
      : getListWithShopId === countShopChecked
        ? true
        : getListWithoutShopId === countShopChecked
          ? false
          : false;
  };

  const columns = [
    {
      title: (
        <Checkbox
          checked={dataShopSearch?.length > 0 && dataShopSearch?.every((s) => s.isChecked)}
          onClick={(e: any) => {
            const isChecked = e.target.checked;
            const storeList = dataForm2?.storeList || [];
            const mapChecked = storeList.map((item: any) => {
              if (
                (searchShopZone ? item.zone === searchShopZone : true) &&
                (searchShopName
                  ? item.customerName.includes(searchShopName) ||
                    item.customerNo.includes(searchShopName.toUpperCase())
                  : true) &&
                (searchShopGroup ? item.customerGroupName === searchShopGroup : true)
              ) {
                return { ...item, isChecked: isChecked };
              }
              return item;
            });
            form2.setFieldValue(["products", (groupNo || 0) - 1, "storeList"], mapChecked);
          }}
        />
      ),
      hidden: isDetail || !dataForm2?.storeList?.length,
      dataIndex: "customerNo",
      key: "customerNo",
      render: (value: any, row: any, i: number) => {
        return {
          children: (
            <>
              <Checkbox
                checked={row.isChecked}
                onClick={(e: any) => {
                  const isChecked = e.target.checked;
                  const storeList = dataForm2?.storeList || [];
                  const updatedStoreList = storeList.map((item: any) => {
                    if (item.customerCompanyId === row.customerCompanyId) {
                      return {
                        ...item,
                        isChecked: isChecked,
                      };
                    }
                    return item;
                  });
                  form2.setFieldValue(
                    ["products", (groupNo || 0) - 1, "storeList"],
                    updatedStoreList,
                  );
                }}
              />
            </>
          ),
        };
      },
    },
    {
      title: "รหัสร้านค้า",
      dataIndex: "customerNo",
      key: "customerNo",
      render: (value: any, row: any, index: number) => {
        return {
          children: <Text>{value}</Text>,
        };
      },
    },
    {
      title: "ชื่อร้านค้า",
      dataIndex: "customerName",
      key: "customerName",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <>
              <Text>{value}</Text>
              <br />
              {row?.isCanNotOrderProductList?.length > 0 &&
                row?.isCanNotOrderProductList?.length < dataProduct?.length && (
                  <>
                    <Text fontFamily='Sarabun' fontSize={14} color='warning'>
                      ร้านนี้ไม่มีสินค้าบางรายการจำหน่าย{" "}
                      <strong>{`${row?.isCanNotOrderProductList?.length} รายการ -`}</strong>{" "}
                      <u
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setModalDupProducts({
                            open: true,
                            products: row?.isCanNotOrderProductList || [],
                            cusName: row.customerName,
                          });
                        }}
                      >
                        ดูเพิ่มเติม
                      </u>
                    </Text>
                    <br />
                  </>
                )}
              {row?.isCanNotOrderProductList?.length === dataProduct?.length && (
                <>
                  <Text fontFamily='Sarabun' fontSize={14} color='error'>
                    ร้านนี้ไม่มีสินค้าโควตาทั้งหมดจำหน่าย{" "}
                    <strong>(รายการจะถูกลบออกเมื่อบันทึก)</strong>
                  </Text>
                  <br />
                </>
              )}
              {row?.isCanNotProductQuotaList?.length > 0 &&
                row?.isCanNotProductQuotaList?.length < dataProduct?.length && (
                  <>
                    <Text fontFamily='Sarabun' level={6} color='warning'>
                      ร้านนี้มีสินค้า{" "}
                      <strong>{`${row?.isCanNotProductQuotaList?.length} รายการ `}</strong>
                      เข้าร่วมกับโควตาอื่น -{" "}
                      <u
                        style={{ cursor: "pointer" }}
                        onClick={async () => {
                          const mapParam = row.isCanNotProductQuotaList?.map((p: any) => {
                            return {
                              productId: p.productId,
                              customerCompanyId: row.customerCompanyId,
                            };
                          });
                          const getDetail = await checkDupPDQuotaDetail({
                            productShop: mapParam,
                            quotaId: isEditing || isDetail ? dataForm1?.quotaId : undefined,
                            startDate,
                            endDate,
                          });
                          setModalDupQuota({
                            open: true,
                            quotas: getDetail || [],
                            cusName: row.customerName,
                          });
                        }}
                      >
                        ดูเพิ่มเติม
                      </u>
                    </Text>
                    <br />
                  </>
                )}
              {row?.isCanNotProductQuotaList?.length === dataProduct?.length && (
                <>
                  <Text fontFamily='Sarabun' fontSize={14} color='error'>
                    ร้านนี้มีสินค้าทั้งหมดเข้าร่วมกับโควตาอื่น{" "}
                    <strong>(รายการจะถูกลบออกเมื่อบันทึก)</strong>
                  </Text>
                  <br />
                </>
              )}
            </>
          ),
        };
      },
    },
    {
      title: "ประเภทคู่ค้า",
      dataIndex: "dealerType",
      key: "dealerType",
      width: 130,
      render: (value: any, row: any, index: number) => {
        return {
          children: <Text level={6}>{dealerTypeName["DEALER"]}</Text>,
        };
      },
    },
    {
      title: "เขต",
      dataIndex: "zone",
      key: "zone",
      render: (value: any, row: any, index: number) => {
        return {
          children: <Text>{value}</Text>,
        };
      },
    },
    {
      title: "กลุ่มลูกค้า",
      dataIndex: "customerGroupName",
      key: "customerGroupName",
      width: 170,
      render: (value: any, row: any, index: number) => {
        return {
          children: <Text>{row.customerGroup || row.customerGroupName || "-"}</Text>,
        };
      },
    },
    {
      title: "โควตาถูกใช้ / ทั้งหมด",
      dataIndex: "quotaUsed",
      key: "quotaUsed",
      hidden: !isDetail && !isEditing,
      render: (value: any, row: any, index: number) => {
        const { quotaUsed, saleUomTh } = row;
        const keyName = `quotaReceive-${row.customerCompanyId}-${groupNo}`;
        const quotaReceive = Number(form2.getFieldValue(keyName)) || 0;
        const percent = quotaReceive > 0 ? (quotaUsed * 100) / quotaReceive : 0;
        return (
          <>
            {row.shopTotalQuotaId ? (
              <>
                {row?.isCanNotProductQuotaList?.length === dataProduct?.length ||
                row?.isCanNotOrderProductList?.length === dataProduct?.length ? (
                  <></>
                ) : (
                  <FlexCol>
                    <Text>
                      {numberFormatter(quotaUsed || 0, 2)}&nbsp;/&nbsp;
                      {numberFormatter(quotaReceive || 0, 2)}
                      &nbsp;{saleUomTh}
                    </Text>
                    <Progress percent={percent} showInfo={false} />
                  </FlexCol>
                )}
              </>
            ) : (
              <>
                {row?.isCanNotProductQuotaList?.length === [dataProduct.productId]?.length ||
                row?.isCanNotOrderProductList?.length === [dataProduct.productId]?.length ? (
                  <></>
                ) : (
                  <Form.Item
                    name={keyName}
                    rules={[{ required: true, message: "โปรดระบุโควตา" }]}
                    style={{ marginBottom: 0 }}
                  >
                    <Input
                      autoComplete='off'
                      placeholder='ระบุจำนวนโควตา'
                      suffix={
                        <>
                          {userCompany?.companyType === "Chemical" ? (
                            <Text fontFamily='Sarabun' fontSize={14}>
                              ลัง/กระสอบ
                            </Text>
                          ) : (
                            <Text fontFamily='Sarabun' fontSize={14}>
                              ตัน
                            </Text>
                          )}
                        </>
                      }
                      onKeyDown={handleNumberOnlyCopyPaste}
                    />
                  </Form.Item>
                )}
              </>
            )}
          </>
        );
      },
    },
    {
      title: (
        <>
          <Text color='white' fontSize={14} fontWeight={700}>
            กำหนดโควตา
          </Text>
          <span style={{ color: color.error }}>*</span>
        </>
      ),
      width: 250,
      dataIndex: "quotaReceive",
      key: "quotaReceive",
      hidden: isDetail || isEditing,
      render: (customerCompanyId: any, row: any, index: number) => {
        const keyName = `quotaReceive-${row.customerCompanyId}-${groupNo}`;
        return (
          <>
            {row?.isCanNotProductQuotaList?.length === dataProduct?.length ||
            row?.isCanNotOrderProductList?.length === dataProduct?.length ? (
              <></>
            ) : (
              <Form.Item
                noStyle
                name={keyName}
                rules={[{ required: true, message: "โปรดระบุโควตา" }]}
              >
                <Input
                  autoComplete='off'
                  placeholder='ระบุจำนวนโควตา'
                  suffix={
                    <>
                      {userCompany?.companyType === "Chemical" ? (
                        <Text fontFamily='Sarabun' fontSize={14}>
                          ลัง/กระสอบ
                        </Text>
                      ) : (
                        <Text fontFamily='Sarabun' fontSize={14}>
                          ตัน
                        </Text>
                      )}
                    </>
                  }
                  onKeyDown={handleNumberOnlyCopyPaste}
                />
              </Form.Item>
            )}
          </>
        );
      },
    },
    {
      title: (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Text
            color='white'
            fontSize={13}
            fontWeight={600}
            lineHeight={20}
            style={{ display: "block", marginBottom: 4 }}
          >
            จำกัดคำสั่งซื้อ / วัน
            <span style={{ color: color.error }}>*</span>
          </Text>
          <Text
            style={{ display: "block" }}
            color='warning'
            fontSize={12}
            fontWeight={600}
            lineHeight={2}
          >
            แบบนับรวมทุกสินค้า
          </Text>
        </div>
      ),
      dataIndex: "limitOrders",
      key: "limitOrders",
      width: 200,
      hidden: !dataForm1?.limitOrderDay,
      render: (_: any, row: any, index: number) => {
        const keyName = `orderPerDay-${row.customerCompanyId}-${groupNo}`;
        return (
          <>
            {row?.isCanNotProductQuotaList?.length === dataProduct?.length ||
            row?.isCanNotOrderProductList?.length === dataProduct?.length ? (
              <></>
            ) : (
              <Form.Item
                noStyle
                name={keyName}
                rules={[{ required: true, message: "โปรดระบุจำนวนคำสั่งซื้อ" }]}
              >
                <Input
                  style={{ color: color.BK }}
                  disabled={dataForm1.limitOrderPerDayType === "allShop" || isDetail}
                  placeholder='ระบุจำนวน'
                  suffix={
                    <Text fontFamily='Sarabun' fontSize={14}>
                      ครั้ง / วัน
                    </Text>
                  }
                  onKeyDown={handleNumberOnlyCopyPaste}
                  autoComplete='off'
                />
              </Form.Item>
            )}
          </>
        );
      },
    },
    {
      title: "โควตาแก้ไข",
      dataIndex: "customerCompanyId",
      key: "edit",
      width: 120,
      hidden: isDetail || !isEditing,
      render: (_: any, record: any) => {
        const keyNameAdjust = `adjustQuota-${record.customerCompanyId}-${groupNo}`;
        const getValueAdjust = form2.getFieldValue(keyNameAdjust);
        const unit = userCompany.companyCode === "ICPL" ? "ลัง" : "ตัน";
        if (record.shopTotalQuotaId) {
          if (getValueAdjust) {
            const isPositive = getValueAdjust > 0;
            return (
              <FlexRow align='center'>
                <Text color={isPositive ? "success" : "error"}>
                  {isPositive ? "+" : "-"} {Math.abs(getValueAdjust)} {unit}
                </Text>
                &nbsp;&nbsp;&nbsp;
                <CloseOutlined
                  style={{ fontSize: 10, fontWeight: 700, cursor: "pointer" }}
                  onClick={() => {
                    form2.setFieldValue(keyNameAdjust, null);
                    form2.setFieldValue(
                      `quotaReceive-${record.customerCompanyId}-${groupNo}`,
                      record.quotaReceive,
                    );
                    form2.setFieldValue("products", form2.getFieldValue("products"));
                  }}
                />
              </FlexRow>
            );
          }
          return (
            <>
              {record?.isCanNotProductQuotaList?.length === dataProduct?.length ||
              record?.isCanNotOrderProductList?.length === dataProduct?.length ? (
                <></>
              ) : (
                <Button
                  title='เพิ่ม/ลดโควตา'
                  typeButton='primary-light'
                  onClick={() =>
                    setModalAdjustQuota({
                      open: true,
                      cusData: record,
                      keyNameAdjust: `adjustQuota-${record.customerCompanyId}-${groupNo}`,
                      keyNameReceive: `quotaReceive-${record.customerCompanyId}-${groupNo}`,
                    })
                  }
                />
              )}
            </>
          );
        } else {
          return <></>;
        }
      },
    },
    {
      title: "สถานะใช้งาน",
      dataIndex: "isActive",
      key: "isActive",
      width: 130,
      hidden: isEditing && !isDetail,
      render: (value: any, row: any, index: number) => {
        return (
          <>
            {row?.isCanNotProductQuotaList?.length === dataProduct?.length ||
            row?.isCanNotOrderProductList?.length === dataProduct?.length ? (
              <></>
            ) : (
              <StatusBadge
                key={index}
                label={STATUS_WORD[value]}
                bgColor={STATUS_WORD_COLOR[value]}
                borderRadius='20px'
              />
            )}
          </>
        );
      },
    },
    {
      title: "เปิด/ปิดรายร้าน",
      dataIndex: "oldIsActive",
      key: "oldIsActive",
      width: 130,
      hidden: !isEditing,
      render: (value: any, row: any, index: number) => {
        return (
          <>
            {row.shopTotalQuotaId ? (
              <>
                {row?.isCanNotProductQuotaList?.length === dataProduct?.length ||
                row?.isCanNotOrderProductList?.length === dataProduct?.length ? (
                  <></>
                ) : (
                  <Switch
                    defaultChecked={!!value}
                    onChange={(checked) => {
                      form2.setFieldValue(
                        ["products", (groupNo || 0) - 1, "storeList", index, "isActive"],
                        checked,
                      );
                    }}
                    checkedChildren={"เปิดใช้งาน"}
                    unCheckedChildren='ปิดใช้งาน'
                  />
                )}
              </>
            ) : (
              <>
                {row?.isCanNotProductQuotaList?.length === dataProduct?.length ||
                row?.isCanNotOrderProductList?.length === dataProduct?.length ? (
                  <></>
                ) : (
                  <StatusBadge
                    key={index}
                    label={STATUS_WORD[value]}
                    bgColor={STATUS_WORD_COLOR[value]}
                    borderRadius='20px'
                  />
                )}
              </>
            )}
          </>
        );
      },
    },
  ].filter((col) => !col.hidden);

  return (
    <>
      <div
        style={{
          margin: "-16px",
          padding: "16px",
          borderBottomRightRadius: "8px",
          borderBottomLeftRadius: "8px",
          backgroundColor: "#BABCBE",
        }}
      >
        <Row gutter={6} style={{ marginBottom: 12 }} justify='start'>
          <Col span={8}>
            <Input
              key={groupNo}
              allowClear
              placeholder='ค้นหารหัส/ชื่อร้าน'
              suffix={<SearchOutlined />}
              onPressEnter={(e: any) => setSearchShopName(e.target.value)}
            />
          </Col>
          <Col span={4}>
            <Select
              placeholder='เขตทั้งหมด'
              fontWeight={400}
              data={zoneList || []}
              value={searchShopZone || "ALL"}
              style={{ width: "100%" }}
              onChange={(e) => {
                if (e) {
                  setSearchShopZone(e);
                } else {
                  setSearchShopZone("ALL");
                }
              }}
            />
          </Col>
          <Col span={4}>
            <Select
              placeholder='กลุ่มลูกค้าทั้งหมด'
              fontWeight={400}
              value={searchShopGroup || "ALL"}
              data={shopGroupData}
              onChange={(e) => {
                if (e) {
                  setSearchShopGroup(e);
                } else {
                  setSearchShopGroup("ALL");
                }
              }}
              style={{ width: "100%" }}
            />
          </Col>
          <Col span={2} />
          {!isDetail && (
            <Col span={6}>
              <Row justify={"end"} gutter={6}>
                <Col>
                  <Button
                    title='ลบร้านค้า'
                    icon={
                      <img
                        src={
                          dataForm2?.storeList?.filter(
                            (s) => s.isChecked && Number(s.quotaUsed) <= 0,
                          )?.length
                            ? icon.deleteWhite
                            : icon.deleteGray
                        }
                        style={{ width: 16, height: 16 }}
                      />
                    }
                    typeButton={
                      dataForm2?.storeList?.filter((s) => s.isChecked && Number(s.quotaUsed) <= 0)
                        ?.length
                        ? "danger"
                        : "light-disabled"
                    }
                    disabled={
                      dataForm2?.storeList?.filter((s) => s.isChecked && Number(s.quotaUsed) <= 0)
                        ?.length === 0
                    }
                    onClick={() => {
                      setModalConfirmDelete(true);
                    }}
                    style={{ width: "max-content" }}
                  />
                </Col>
                <Col>
                  <Button
                    onClick={() => setModalSelectStore(true)}
                    title='เพิ่มร้านค้า'
                    icon={<PlusOutlined />}
                    style={{ width: "max-content" }}
                  />
                </Col>
              </Row>
            </Col>
          )}
        </Row>
        <Row gutter={[10, 10]} style={{ marginBottom: 12 }} justify='end'>
          {[
            {
              icon: <ScanOutlined style={{ fontSize: "18px" }} />,
              title: "เพิ่มเงื่อนไขเดียวกัน",
            },
            // {
            //   icon: <UploadOutlined />,
            //   title: "Export & Import",
            //   //onClick: () => isOpenExport?.(true),
            // },
          ].map((btn, idx) => (
            <>
              <Col style={{ paddingTop: "8px" }}>
                <Text>{`จำนวน ${numberFormatter(dataForm2?.storeList?.length || 0, 0)} ร้านค้า`}</Text>
              </Col>
              {!isDetail && (
                <Col
                  key={idx}
                  xs='auto'
                  sm='auto'
                  md='auto'
                  lg='auto'
                  xl='auto'
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Button
                    onClick={() =>
                      dataForm2?.storeList?.filter((s) => s.isChecked).length > 0
                        ? checkDisableCondition()
                          ? undefined
                          : setModalSettingCondition(true)
                        : setModalIntructCondition(true)
                    }
                    style={{ width: "max-content" }}
                    icon={btn.icon}
                    title={btn.title}
                    typeButton={
                      dataForm2?.storeList?.filter((s) => s.isChecked).length === 0
                        ? "border-primary"
                        : checkDisableCondition()
                          ? "light-disabled"
                          : "border-primary"
                    }
                  />
                </Col>
              )}
            </>
          ))}
        </Row>
        <TableContainer>
          {loadingComponent ? (
            <CardContainer>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "30vh",
                }}
              >
                <Spin />
              </div>
            </CardContainer>
          ) : (
            <Form.Item name={"products"} noStyle>
              <Table
                key={groupNo}
                columns={columns}
                dataSource={dataShopSearch || []}
                scroll={{
                  x: dataShopSearch?.length > 0 ? "max-content" : 0,
                  y: 520,
                }}
                pagination={false}
              />
            </Form.Item>
          )}
        </TableContainer>
      </div>
      {modalSelectStore && (
        <ModalSelectStore
          showModalShop
          excludeCusCompanyId={dataForm2?.storeList?.map((s) => s.customerCompanyId) || []}
          callBackShop={(stores) => {
            form2.setFieldValue(
              ["products", dataForm2?.groupNo - 1, "storeList"],
              [
                ...(dataForm2?.storeList || []),
                ...stores.map((s) => ({
                  ...s,
                  isChecked: false,
                  oldIsActive: true,
                  quotaReceive: null,
                  orderPerDay: null,
                })),
              ],
            );
            setModalSelectStore(false);
          }}
          currentSelectShop={dataForm2?.storeList || []}
          company={userCompany.companyCode}
          onClose={() => {
            setModalSelectStore(false);
          }}
          customerType='DL'
          replaceSaveButtonTitle='บันทึก'
          replaceTitle={
            <FlexCol>
              <Text level={4} fontWeight={700}>
                เพิ่มร้านค้าและสินค้า
              </Text>
              <br />
              <FlexRow align='end'>
                <Text color='Text3' level={6}>
                  เลือกได้มากกว่า 1 ร้านค้า
                </Text>
              </FlexRow>
            </FlexCol>
          }
          hideCurrect
        />
      )}
      {modalConfirmDelete && (
        <ConfirmModal
          visible={modalConfirmDelete}
          onConfirm={() => {
            deleteShop();
            setModalConfirmDelete(false);
          }}
          onCancel={() => {
            setModalConfirmDelete(false);
          }}
          typeButtonSubmit='danger'
          typeButtonCancel='border-danger'
          title={`ต้องการลบร้านค้า ${form2.getFieldValue(["products", groupIndex, "storeList"]).filter((s) => s.isChecked).length} รายการ`}
          desc='โปรดตรวจสอบรายละเอียดอีกครั้งก่อนการกดยืนยัน เพราะอาจส่งผลต่อข้อมูลร้านค้าในระบบ'
        />
      )}
      {modalIntructCondition && (
        <InstuctionQuotaConditions
          open={modalIntructCondition}
          onClose={() => setModalIntructCondition(false)}
        />
      )}
      {modalSettingCondition && (
        <SettingConditionQuotaEachShop
          open={modalSettingCondition}
          onClose={() => setModalSettingCondition(false)}
          onSubmit={(q, l, conditionType) => {
            setLoadingComponent(false);
            const findValue = dataForm2?.storeList || [];
            const mapValue = findValue?.map((item) => {
              const keyForm = `${item?.customerCompanyId}-${groupNo}`;
              if (item.isChecked) {
                if (!item.shopTotalQuotaId) {
                  form2.setFieldValue(
                    `quotaReceive-${keyForm}`,
                    conditionType.includes("quota")
                      ? q
                      : form2.getFieldValue(`quotaReceive-${keyForm}`) || null,
                  );
                  form2.setFieldValue(
                    `orderPerDay-${keyForm}`,
                    conditionType.includes("limit")
                      ? l
                      : form2.getFieldValue(`orderPerDay-${keyForm}`) || null,
                  );
                } else {
                  form2.setFieldValue(
                    `orderPerDay-${keyForm}`,
                    conditionType.includes("limit")
                      ? l
                      : form2.getFieldValue(`orderPerDay-${keyForm}`) || null,
                  );
                }

                return {
                  ...item,
                  isChecked: false,
                };
              }
              return item;
            });
            form2.setFieldValue(["products", (groupNo || 0) - 1, "storeList"], mapValue);
            setModalSettingCondition(false);
            setTimeout(() => {
              setLoadingComponent(false);
            }, 400);
          }}
          showQuota={dataForm1.quotaType !== "QUOTA_TOTAL"}
          showLimit={dataForm1.limitOrderDay}
          typeLimitQuota={dataForm1.limitOrderPerDayType}
          countOrder={dataForm1.countOrder}
        />
      )}
      {modalDupProducts.open && (
        <ModalCheckProductDup
          visible={modalDupProducts.open}
          onCancel={() => setModalDupProducts({ open: false, products: [], cusName: "" })}
          products={modalDupProducts?.products}
          cusName={modalDupProducts?.cusName}
        />
      )}
      {modalDupQuota.open && (
        <ModalCheckQuotaDup
          open={modalDupQuota.open}
          onCancel={() => setModalDupQuota({ open: false, quotas: [], cusName: "" })}
          datas={modalDupQuota?.quotas}
          cusName={modalDupQuota?.cusName}
        />
      )}
      {modalAdjustQuota.open && (
        <ModalAdjustQuota
          open={modalAdjustQuota.open}
          setOpen={(value) => setModalAdjustQuota({ ...modalAdjustQuota, open: value })}
          cusData={modalAdjustQuota?.cusData}
          keyNameAdjust={modalAdjustQuota?.keyNameAdjust}
          keyNameReceive={modalAdjustQuota?.keyNameReceive}
          onSubmit={(value, keyNameAdjust, keyNameReceive) => {
            const quotaCurrent = Number(form2.getFieldValue(keyNameReceive)) || 0;
            if (Number(value.adjustType) < 0) {
              form2.setFieldValue(keyNameReceive, quotaCurrent - Number(value.adjustValue));
            } else {
              form2.setFieldValue(keyNameReceive, quotaCurrent + Number(value.adjustValue));
            }
            form2.setFieldValue(
              keyNameAdjust,
              Number(value.adjustValue) * Number(value.adjustType),
            );
            setModalAdjustQuota({ open: false, cusData: {} });
          }}
        />
      )}
    </>
  );
};
//#endregion
